var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCautionSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "caution-small_svg__a",
  d: "M11 15h1v2h-1zM11.5.47 22.35 20H.65zm0 2.06L2.35 19h18.3zM12 7v6h-1V7z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "caution-small_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#caution-small_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#caution-small_svg__a",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#BB0A30",
  mask: "url(#caution-small_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0-1h24v24H0z"
})))));
export { SvgCautionSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0icXNtd3FoeDQ1YSIgZD0iTTExIDE1aDF2MmgtMXYtMnpNMTEuNS40N0wyMi4zNSAyMEguNjVMMTEuNS40N3ptMCAyLjA2TDIuMzUgMTloMTguM0wxMS41IDIuNTN6TTEyIDd2NmgtMVY3aDF6Ii8+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMCAtMTAyKSB0cmFuc2xhdGUoMTIgNzIpIHRyYW5zbGF0ZSgxOCAzMSkiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJramV5MTB6dTNiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcXNtd3FoeDQ1YSIvPgogICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8dXNlIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI3FzbXdxaHg0NWEiLz4KICAgICAgICAgICAgICAgICAgICA8ZyBmaWxsPSIjQkIwQTMwIiBtYXNrPSJ1cmwoI2tqZXkxMHp1M2IpIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAgMEgyNFYyNEgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMSkiLz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";